import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useExtractActionService} from "app/utils/services/extractService";

const useEmailModal = () => {
    const { t } = useTranslation();



    return {
        t
    }
};

export default useEmailModal;